import React, { useState } from 'react';
import { Spinner } from 'react-bootstrap';

import Section from 'components/Meteorology/Shared/ControlPanelSheet/Section';
import OptionRow from 'components/Meteorology/Shared/ControlPanelSheet/OptionRow';
import useAutomaticOptions from 'utils/hooks/flux/useAutomaticOptions';

import './index.scss';

// Sub-accordion por grupo (nível 2) — mesmo padrão do ModelSection do Comparador Clássico
// (Meteorology/Fields/ClassicComparator/Mobile/ControlPanelSheet/ModelSection). No desktop
// (ControlPanel/AutomaticStudy) cada grupo já é um Accordion.Item próprio; aqui listar todos
// os cenários de todos os grupos de uma vez (sem recolher por grupo) deixava a seção enorme.
export default function AutomaticStudy() {
  const [openGroup, setOpenGroup] = useState('');
  const {
    labeledScenarios, isFetching, switchOptionsSelection, checkOptionSelection,
  } = useAutomaticOptions();

  if (isFetching) {
    return (
      <div className="flux-automatic-study-loading">
        <Spinner animation="border" />
      </div>
    );
  }

  return (
    <div className="flux-automatic-study-groups">
      {labeledScenarios.map((group) => {
        const selectedCount = group.scenarios.filter(
          (scenario) => checkOptionSelection(scenario.scenario),
        ).length;

        return (
          <Section
            key={group.label}
            label={group.label}
            valueText={selectedCount ? `${selectedCount} selecionado(s)` : undefined}
            open={openGroup === group.label}
            onToggle={() => setOpenGroup((current) => (
              current === group.label ? '' : group.label
            ))}
          >
            {group.scenarios.map((scenario) => (
              <OptionRow
                key={scenario.scenario}
                label={scenario.scenario}
                selectionType="multiple"
                selected={checkOptionSelection(scenario.scenario)}
                disabled={!scenario.selectable}
                onSelect={() => switchOptionsSelection(scenario.scenario)}
              />
            ))}
          </Section>
        );
      })}
    </div>
  );
}
